import type { RouteRecordRaw } from 'vue-router'
import auth from '@/middleware/auth'

// Authentication routes (guest only)
export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      layout: 'auth',
      title: 'Sign In',
      requiresAuth: false,
      guestOnly: true,
    },
  },
]

// Dashboard routes
export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Dashboard',
      breadcrumb: 'Dashboard',
      icon: 'home',
      requiresAuth: true,
      order: 1,
    },
  },
]

// // Product management routes
export const productRoutes: RouteRecordRaw[] = [
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/products/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Products',
      breadcrumb: 'Products',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_products'],
      order: 2,
    },
  },
  {
    path: '/products/create',
    name: 'products-create',
    component: () => import('@/views/products/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create Product',
      breadcrumb: 'Create Product',
      requiresAuth: true,
      requiredPermissions: ['create_products'],
    },
  },
  {
    path: '/products/:id',
    name: 'products-detail',
    component: () => import('@/views/products/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Product',
      breadcrumb: 'Product',
      requiresAuth: true,
      requiredPermissions: ['view_products'],
    },
  },
  {
    path: '/products/:id/edit',
    name: 'products-edit',
    component: () => import('@/views/products/edit.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Product',
      breadcrumb: 'Product',
      requiresAuth: true,
      requiredPermissions: ['edit_products'],
    },
  },
]

export const markingRoutes: RouteRecordRaw[] = [
  {
    path: '/marking',
    name: 'marking',
    component: () => import('@/views/marking/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Marking',
      breadcrumb: 'Marking',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_marking'],
      order: 2,
    },
  },
  {
    path: '/marking/generate',
    name: 'marking-generate',
    component: () => import('@/views/marking/generate.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Generate marking',
      breadcrumb: 'Generate marking',
      requiresAuth: true,
      requiredPermissions: ['generate_marking'],
    },
  },
  {
    path: '/marking/:id',
    name: 'batch-detail',
    component: () => import('@/views/marking/batchDetail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Marking',
      breadcrumb: 'Marking',
      requiresAuth: true,
      requiredPermissions: ['view_marking'],
    },
  },
  {
    path: '/marking/:id/codes/:codeId',
    name: 'marking-detail',
    component: () => import('@/views/marking/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Marking',
      breadcrumb: 'Marking',
      requiresAuth: true,
      requiredPermissions: ['view_marking'],
    },
  },
  {
    path: '/codes/:codeId',
    name: 'marking-code-detail',
    component: () => import('@/views/marking/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Marking',
      breadcrumb: 'Marking',
      requiresAuth: true,
      requiredPermissions: ['view_marking'],
    },
  },
]

export const utilizationRoutes: RouteRecordRaw[] = [
  {
    path: '/utilizations',
    name: 'utilizations',
    component: () => import('@/views/utilizations/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Uzilizations',
      breadcrumb: 'Uzilizations',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_utilizations'],
      order: 2,
    },
  },
  {
    path: '/utilizations/:id',
    name: 'utilizations-detail',
    component: () => import('@/views/utilizations/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Uzilization',
      breadcrumb: 'Uzilization',
      requiresAuth: true,
      requiredPermissions: ['view_utilizations'],
    },
  },
]

export const warehousesRoutes: RouteRecordRaw[] = [
  {
    path: '/warehouses',
    name: 'warehouses',
    component: () => import('@/views/warehouses/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'warehouses',
      breadcrumb: 'warehouses',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_warehouses'],
      order: 2,
    },
  },
  {
    path: '/warehouses/inventory',
    name: 'warehouses-inventory',
    component: () => import('@/views/warehouses/inventory.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'inventory',
      breadcrumb: 'inventory',
      icon: 'clipboard',
      requiresAuth: true,
      requiredPermissions: ['view_warehouses'],
      order: 3,
    },
  },
  {
    path: '/warehouses/create',
    name: 'warehouses-create',
    component: () => import('@/views/warehouses/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create Product',
      breadcrumb: 'Create Product',
      requiresAuth: true,
      requiredPermissions: ['create_warehouses'],
    },
  },
  {
    path: '/warehouses/:id',
    name: 'warehouses-detail',
    component: () => import('@/views/warehouses/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Warehouse',
      breadcrumb: 'Warehouse',
      requiresAuth: true,
      requiredPermissions: ['view_warehouses'],
    },
  },
  {
    path: '/warehouses/:id/edit',
    name: 'warehouses-edit',
    component: () => import('@/views/warehouses/edit.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Warehouse',
      breadcrumb: 'Warehouse',
      requiresAuth: true,
      requiredPermissions: ['edit_warehouses'],
    },
  },
]

export const tasksRoutes: RouteRecordRaw[] = [
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@/views/tasks/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'tasks',
      breadcrumb: 'tasks',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_tasks'],
      order: 2,
    },
  },
  {
    path: '/tasks/create',
    name: 'tasks-create',
    component: () => import('@/views/tasks/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create task',
      breadcrumb: 'Create task',
      requiresAuth: true,
      requiredPermissions: ['create_tasks'],
    },
  },
  {
    path: '/tasks/:id',
    name: 'tasks-detail',
    component: () => import('@/views/tasks/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Task',
      breadcrumb: 'Task',
      requiresAuth: true,
      requiredPermissions: ['view_tasks'],
    },
  },
  {
    path: '/tasks/:id/edit',
    name: 'tasks-edit',
    component: () => import('@/views/tasks/edit.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Task',
      breadcrumb: 'Task',
      requiresAuth: true,
      requiredPermissions: ['edit_tasks'],
    },
  },
  {
    path: '/tasks/:id/scan',
    name: 'tasks-scan',
    component: () => import('@/views/tasks/scan.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Scan Task',
      breadcrumb: 'Scan Task',
      requiresAuth: true,
      requiredPermissions: ['view_tasks'],
    },
  },
]

export const contractorsRoutes: RouteRecordRaw[] = [
  {
    path: '/contractors',
    name: 'contractors',
    component: () => import('@/views/contractors/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'contractors',
      breadcrumb: 'contractors',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_contractors'],
      order: 2,
    },
  },
  {
    path: '/contractors/create',
    name: 'contractors-create',
    component: () => import('@/views/contractors/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create task',
      breadcrumb: 'Create task',
      requiresAuth: true,
      requiredPermissions: ['create_contractors'],
    },
  },
  {
    path: '/contractors/:id',
    name: 'contractors-detail',
    component: () => import('@/views/contractors/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Task',
      breadcrumb: 'Task',
      requiresAuth: true,
      requiredPermissions: ['view_contractors'],
    },
  },
  {
    path: '/contractors/:id/edit',
    name: 'contractors-edit',
    component: () => import('@/views/contractors/edit.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Task',
      breadcrumb: 'Task',
      requiresAuth: true,
      requiredPermissions: ['edit_contractors'],
    },
  },
]

export const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/users/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'users',
      breadcrumb: 'users',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_users'],
      order: 2,
    },
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: () => import('@/views/users/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create task',
      breadcrumb: 'Create task',
      requiresAuth: true,
      requiredPermissions: ['create_users'],
    },
  },
  {
    path: '/users/:id',
    name: 'users-detail',
    component: () => import('@/views/users/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Task',
      breadcrumb: 'Task',
      requiresAuth: true,
      requiredPermissions: ['view_users'],
    },
  },
  {
    path: '/users/:id/edit',
    name: 'users-edit',
    component: () => import('@/views/users/edit.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Task',
      breadcrumb: 'Task',
      requiresAuth: true,
      requiredPermissions: ['edit_users'],
    },
  },
]

export const documentsRoutes: RouteRecordRaw[] = [
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/views/documents/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'documents',
      breadcrumb: 'documents',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_documents'],
    },
  },
  {
    path: '/documents/create',
    name: 'documents-create',
    component: () => import('@/views/documents/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'documents',
      breadcrumb: 'create',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['create_documents'],
    },
  },
  {
    path: '/documents/create/invoice',
    name: 'documents-create-invoice',
    component: () => import('@/views/documents/create-invoice.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'documents',
      breadcrumb: 'create',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['create_documents'],
    },
  },
  {
    path: '/documents/edit/invoice/:id',
    name: 'documents-edit-invoice',
    component: () => import('@/views/documents/edit-invoice.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'documents',
      breadcrumb: 'create',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['create_documents'],
    },
  },
  {
    path: '/documents/create/transport',
    name: 'documents-create-transport',
    component: () => import('@/views/documents/create-transport.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'documents',
      breadcrumb: 'create',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['create_documents'],
    },
  },
]

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'settings',
      breadcrumb: 'settings',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_settings'],
      order: 2,
    },
  },
]

export const userRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/profile.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'profile',
      breadcrumb: 'profile',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: [],
      order: 2,
    },
  },
]

export const esfRoutes: RouteRecordRaw[] = [
  {
    path: '/esf',
    name: 'esf',
    component: () => import('@/views/esf/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'ESF',
      breadcrumb: 'ESF',
      icon: 'document-text',
      requiresAuth: true,
      order: 3,
    },
  },
]

export const aggregationsRoutes: RouteRecordRaw[] = [
  {
    path: '/aggregations',
    name: 'aggregations',
    component: () => import('@/views/aggregations/index.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'aggregations',
      breadcrumb: 'aggregations',
      icon: 'cube',
      requiresAuth: true,
      requiredPermissions: ['view_aggregations'],
      order: 2,
    },
  },
  {
    path: '/aggregations/create',
    name: 'aggregations-create',
    component: () => import('@/views/aggregations/create.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create Aggregation',
      breadcrumb: 'Create Aggregation',
      requiresAuth: true,
      requiredPermissions: ['create_aggregations'],
    },
  },
  {
    path: '/aggregations/create/kigu',
    name: 'aggregations-create-kigu',
    component: () => import('@/views/aggregations/create-kigu.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create Aggregation KIGU',
      breadcrumb: 'Create Aggregation KIGU',
      requiresAuth: true,
      requiredPermissions: ['create_aggregations'],
    },
  },
  {
    path: '/aggregations/create/auto',
    name: 'aggregations-create-auto',
    component: () => import('@/views/aggregations/create-auto.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Auto Aggregation',
      breadcrumb: 'Auto Aggregation',
      requiresAuth: true,
      requiredPermissions: ['create_aggregations'],
    },
  },
  {
    path: '/aggregations/create/kitu',
    name: 'aggregations-create-kitu',
    component: () => import('@/views/aggregations/create-kitu.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Create Aggregation KITU',
      breadcrumb: 'Create Aggregation KITU',
      requiresAuth: true,
      requiredPermissions: ['create_aggregations'],
    },
  },
  {
    path: '/aggregations/:id',
    name: 'aggregations-detail',
    component: () => import('@/views/aggregations/detail.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Aggregation',
      breadcrumb: 'Aggregation',
      requiresAuth: true,
      requiredPermissions: ['view_aggregations'],
    },
  },
  {
    path: '/aggregations/:id/add-code',
    name: 'aggregations-add-code',
    component: () => import('@/views/aggregations/add-code.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'Aggregation',
      breadcrumb: 'Aggregation',
      requiresAuth: true,
      requiredPermissions: ['view_aggregations'],
    },
  },
  {
    path: '/aggregations/:id/add-code-kitu',
    name: 'aggregations-add-code-kitu',
    component: () => import('@/views/aggregations/add-code-kitu.vue'),
    meta: {
      middleware: [auth],
      layout: 'AppLayout',
      title: 'KITU Aggregation',
      breadcrumb: 'KITU Aggregation',
      requiresAuth: true,
      requiredPermissions: ['view_aggregations'],
    },
  },
]

// Combine all routes
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },

  {
    path: '/e-imzo',
    name: 'e-imzo',
    component: () => import('@/views/e-imzo.vue'),
  },

  ...authRoutes,
  ...dashboardRoutes,
  ...productRoutes,
  ...markingRoutes,
  ...warehousesRoutes,
  ...tasksRoutes,
  ...documentsRoutes,
  ...settingsRoutes,
  ...userRoutes,
  ...contractorsRoutes,
  ...usersRoutes,
  ...aggregationsRoutes,
  ...esfRoutes,
  ...utilizationRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not-found',
  },
]

// Export route groups for navigation menu generation
// export const navigationRoutes = [
//     ...dashboardRoutes,
//     ...productRoutes,
//     ...markingCodeRoutes,
//     ...taskRoutes,
//     ...documentRoutes,
//     ...integrationRoutes,
//     ...userRoutes,
//     ...settingsRoutes
// ].filter(route => !route.meta?.hidden)
